document.addEventListener('DOMContentLoaded', function () {
  console.log("✅ Mobile Mega Menu JS Loaded");

  const tabs = document.querySelectorAll('.mobile-mega-menu__tabs .tab');
  const contents = document.querySelectorAll('.mobile-mega-menu__content');

  if (!tabs.length || !contents.length) return;

  tabs.forEach(tab => {
    tab.addEventListener('click', (e) => {
      e.preventDefault(); // Prevents # from changing the URL
      e.stopPropagation(); // Stops propagation so the drawer doesn't close

      const target = tab.getAttribute('data-tab');

      // Remove active state from all tabs and hide all content
      tabs.forEach(t => {
        t.classList.remove('active');
        t.setAttribute('aria-selected', 'false');
      });

      contents.forEach(c => {
        c.classList.remove('active');
        c.setAttribute('hidden', '');
      });

      // Add active state to clicked tab and show corresponding content
      tab.classList.add('active');
      tab.setAttribute('aria-selected', 'true');

      const contentToShow = document.querySelector(`.mobile-mega-menu__content[data-content="${target}"]`);
      if (contentToShow) {
        contentToShow.classList.add('active');
        contentToShow.removeAttribute('hidden');
      }
    });
  });
});
